module.exports = __webpack_public_path__ + "static/img/header.c2fac66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.png
// module id = nvbl
// module chunks = 0